<template>
  <div class="memberDocuments">
    <v-container>
      <v-data-table
        :headers="headers"
        :items="documentList"
        :items-per-page="-1"
        :item-class="itemRowBackground"
        @click:row="rowClick"
      >
      </v-data-table>
      <div class="btnContainer">
        <v-btn @click="addDocument" color="primary">Upload Document</v-btn>
        <v-btn @click="viewDocument" color="secondary">View Document</v-btn>
        <v-btn @click="downloadDocument" color="secondary">Download Document</v-btn>
        <v-btn @click="onDelete" color="teal">Delete Document</v-btn>
      </div>
    </v-container>
    <v-dialog v-model="uploadDialog" width="600">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Upload Document </v-card-title>

        <v-card-text>
          <v-select label="Document Type" :items="typesList" v-model="documentType"></v-select>
          <v-text-field label="Description" v-model="description"></v-text-field>
          <v-file-input
            v-model="uploadFile"
            ref="file"
            label="Member Document"
            accept=".jpg, .pdf, .bmp, .docx, .png"
            dense
          ></v-file-input>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="uploadDocument"> Ok </v-btn>
          <v-btn color="secondary" text @click="uploadDialog = false"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Dialog ref="confirmationDialog" />
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';

export default {
  name: 'MemberDocuments',
  components: { Dialog },

  data: () => ({
    selectedLink: null,
    selectedRow: null,
    uploadFile: null,
    documentType: '',
    description: '',
    uploadDialog: false,
    typesList: [
      'Birth Certificate',
      'Driving Licence',
      'Marriage Certificate',
      'Photo',
      'Signature',
      'Statement',
      'Other',
    ],
    documentList: [],
    headers: [
      { text: 'Document Type', value: 'Reference' },
      { text: 'Document Name', value: 'ShortName' },
      { text: 'Description', value: 'Description' },
      { text: 'Upload Date', value: 'Date' },
    ],
  }),

  computed: {
    memberId() {
      var memno = this.$store.state.selectedMemberId;
      console.log('compute' + memno);
      return this.$store.state.selectedMemberId;
    },
  },
  mounted: function () {
    if (!this.memberId) {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    } else {
      this.getDocumentList();
    }
  },
  watch: {
    memberId() {
      this.getDocumentList();
    },
  },
  methods: {
    itemRowBackground: function (item) {
      return item == this.selectedRow ? 'selected' : '';
    },
    rowClick: function (item) {
      this.selectedRow = item;
    },
    addDocument: function () {
      this.uploadDialog = true;
    },

    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('en-GB', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
      });
    },

    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.isSidebarShown = false;
        this.deleteDocument();
      } catch (err) {
        console.log();
      }
    },

    async viewDocument() {
      var id = this.selectedRow.Id;
      try {
        const response = await this.$api.get(
          '/document/viewMemberDocument?membershipId=' + this.memberId + '&documentId=' + id,
          {
            responseType: 'blob',
          }
        );
        
        if (response && response.data) {
          const mimeType = response.headers['content-type'] || 'application/octet-stream';
          const blob = new Blob([response.data], { type: mimeType });

          const url = URL.createObjectURL(blob);
          const newTab = window.open(url, '_blank');
          if (!newTab) {
            console.warn('Popup blocked. User may need to allow popups for this site.');
          }
          setTimeout(() => URL.revokeObjectURL(url), 10000);

          console.log('File downloaded successfully!');
        } else {
          console.error('No data in response.');
        }
      } catch (error) {
        console.error('Error making GET request:', error);
      }
    },

    async downloadDocument() {
      var id = this.selectedRow.Id;
      try {
        const response = await this.$api.get(
          '/document/viewMemberDocument?membershipId=' + this.memberId + '&documentId=' + id,
          {
            responseType: 'blob',
          }
        );
        
        if (response && response.data) {
          const mimeType = response.headers['content-type'] || 'application/octet-stream';
          const blob = new Blob([response.data], { type: mimeType });
          const fileName = response.headers['content-disposition']
            ? response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '')
            : 'downloaded_file.pdf';

          const url = URL.createObjectURL(blob);
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = fileName;
          downloadLink.click();
          URL.revokeObjectURL(url);

          console.log('File downloaded successfully!');
        } else {
          console.error('No data in response.');
        }
      } catch (error) {
        console.error('Error making GET request:', error);
      }
    },

    async uploadDocument() {
      try {
        let data = new FormData();
        data.append('MembershipId', this.memberId);
        data.append('DocumentType', this.documentType);
        data.append('Description', this.description);
        data.append('File', this.uploadFile);
        await this.$api({
          url: '/Document/UploadMemberDocument',
          method: 'POST',
          data: data,
        });

        this.uploadDialog = false;
        this.getDocumentList();
      } catch (error) {
        console.error(error);
        this.$store.commit('setNotificationMessage', { type: 'error', text: error.message });
      }
    },
    async deleteDocument() {
      try {
        await this.$api.delete('/Document/deleteMemberDocument?id=' + this.selectedRow.Id);

        this.getDocumentList();
      } catch (err) {
        console.error(err);
      }
    },

    async getDocumentList() {
      try {
        console.log(this.memberId);
        let response = await this.$api.get(
          '/Document/GetMemberDocuments?membershipid=' + this.memberId
        );

        this.documentList = response.data;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.memberDocuments {
  .selected {
    background-color: #778899 !important;
  }

  .btnContainer button {
    margin-right: 10px;
  }

  .btnContainer a {
    margin-right: 10px;
  }

  tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
</style>
